module.exports = __webpack_public_path__ + "static/img/3b.8eb35c71.webp";